const getStatementsByDate = ({ statements, year, month }) => statements.filter(statement => {
    const statementYear = Number(new Date(statement.periodFrom).getFullYear());
    const statementMonth = Number(new Date(statement.periodFrom).getMonth() + 1);
    return statementYear === year && statementMonth === month;
});
const getInstructionAmounts = (totals, instruction) => {
    const { debits, credits, fees, type } = instruction;
    if (debits > 0) {
        return {
            ...totals,
            withdrawalsAndOtherDebits: totals.withdrawalsAndOtherDebits + debits
        };
    }
    if (fees > 0) {
        return {
            ...totals,
            penaltyFee: totals.penaltyFee + fees
        };
    }
    if (credits > 0) {
        if (type === 'INTEREST_POSTING') {
            return {
                ...totals,
                interestPaid: totals.interestPaid + credits
            };
        }
        return {
            ...totals,
            depositsAndOtherCredits: totals.depositsAndOtherCredits + credits
        };
    }
    return totals;
};
const getStatementSummaryRow = ({ statement }) => {
    const { productBank, productName, accountID, openingBalance, closingBalance, interestRate, apyEarned, interestYTD } = statement;
    const initialStatement = {
        withdrawalsAndOtherDebits: 0,
        depositsAndOtherCredits: 0,
        interestPaid: 0,
        penaltyFee: 0
    };
    const calculatedAmounts = statement.transactions
        ? statement.transactions.reduce(getInstructionAmounts, initialStatement)
        : initialStatement;
    return {
        ...calculatedAmounts,
        productBank,
        productName,
        accountID,
        startingBalance: openingBalance,
        endingBalance: closingBalance,
        interestRate,
        apyEarned,
        interestYTD
    };
};
export const getStatementSummaryRowsFiltered = ({ statements, year, month }) => {
    const filteredStatements = getStatementsByDate({ statements, year, month });
    return filteredStatements.map(statement => getStatementSummaryRow({ statement }));
};
export const getStatementSummaryRows = ({ statements }) => statements.map(statement => getStatementSummaryRow({ statement }));
export const sortStatementRowsByField = ({ statementSummaryRows, field }) => statementSummaryRows.sort((a, b) => {
    if (a[field] < b[field]) {
        return -1;
    }
    if (a[field] > b[field]) {
        return 1;
    }
    return 0;
});
export const getStatementSummaryGrandTotals = ({ statementSummaryRows }) => Object.values(statementSummaryRows).reduce((totals, summaryRow) => ({
    startingBalance: totals.startingBalance + summaryRow.startingBalance,
    withdrawalsAndOtherDebits: totals.withdrawalsAndOtherDebits + summaryRow.withdrawalsAndOtherDebits,
    depositsAndOtherCredits: totals.depositsAndOtherCredits + summaryRow.depositsAndOtherCredits,
    interestPaid: totals.interestPaid + summaryRow.interestPaid,
    penaltyFee: totals.penaltyFee + summaryRow.penaltyFee,
    endingBalance: totals.endingBalance + summaryRow.endingBalance
}), {
    startingBalance: 0,
    withdrawalsAndOtherDebits: 0,
    depositsAndOtherCredits: 0,
    interestPaid: 0,
    penaltyFee: 0,
    endingBalance: 0
});
